import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FormTextField } from "../../../../../../../components/fields";
import { IFormValues } from "../../../../../types";

const MainDriverDetails = () => {

    const { t } = useTranslation('booking');

    return (
        <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                    <Typography variant="h5">
                        {t('label.mainDriver')}
                    </Typography>
                </Stack>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container rowSpacing={1} columnSpacing={3}>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDriverDetails.id"
                            label={t('label.id')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDriverDetails.firstName"
                            label={t('label.firstName')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDriverDetails.lastName"
                            label={t('label.lastName')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDriverDetails.birthDate"
                            label={t('label.birthDate')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDriverDetails.birthNation"
                            label={t('label.nationOfBirth')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDriverDetails.birthPlace"
                            label={t('label.placeOfBirth')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDriverDetails.residenceCountry"
                            label={t('label.countryOfResidence')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDriverDetails.fiscalCode"
                            label={t('label.fiscalCode')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDriverDetails.gender"
                            label={t('label.gender')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDriverDetails.drivingLicenseNumber"
                            label={t('label.drivingLicenseNumber')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDriverDetails.email"
                            label={t('label.email')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <FormTextField<IFormValues>
                            name="mainDriverDetails.mobilePrefix"
                            label={t('label.prefix')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormTextField<IFormValues>
                            name="mainDriverDetails.mobile"
                            label={t('label.mobile')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="mainDriverDetails.webCheckIn"
                            label={t('label.webCheckIn')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion >
    )
};

export default MainDriverDetails;
